import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type TaskService from 'volta/services/task-service';

interface IArgs {
  entityId: string;
}

export default class CommentModal extends Component<IArgs> {
  @service taskService!: TaskService;

  @tracked isListVisible = false;

  /**
   * Scroll the comment-list to the bottom to show the most recent comments
   */
  @action
  scrollComments(element: HTMLElement) {
    element.scrollTo({ top: element.scrollHeight, behavior: 'smooth' });
  }

  @action
  toggleList(fetchComments: () => void) {
    if (this.isListVisible) {
      this.hideList();
    } else {
      fetchComments();
      this.showList();
    }
  }

  @action
  showList() {
    this.isListVisible = true;
  }

  @action
  hideList() {
    this.isListVisible = false;
  }
}
